import { render, staticRenderFns } from "./visitor-car-record.vue?vue&type=template&id=a56ab870&"
import script from "./visitor-car-record.vue?vue&type=script&lang=js&"
export * from "./visitor-car-record.vue?vue&type=script&lang=js&"
import style0 from "./visitor-car-record.vue?vue&type=style&index=0&id=a56ab870&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports